import { ITreeNode } from '@blueprintjs/core'
import get from 'lodash/fp/get'
import { LocationNodeType } from '../../components/LocationGroupTrees/components'
import { LocationTreeNodeT } from './forEachNode'

const makeDisableEachNodeBySelectedFloors =
  (disabledFloorIds: string[]) =>
  (parent: ITreeNode): void => {
    const nodeType = (parent as LocationTreeNodeT).nodeData?.nodeType
    const hasDisabledFloorId = (floorTreeNode: ITreeNode) =>
      disabledFloorIds.includes(getFloorId(floorTreeNode))

    selectedFloorPredicatesMap[nodeType as LocationNodeType]?.(parent, hasDisabledFloorId)
  }

export default makeDisableEachNodeBySelectedFloors

type HasSelectedFloor = (
  treeNode: ITreeNode,
  hasDisabledFloorId: (treeNode: ITreeNode) => boolean
) => void

const hasLocationSelectedFloor: HasSelectedFloor = (treeNode, hasDisabledFloorId) => {
  treeNode.disabled = treeNode.childNodes?.every((city) =>
    city.childNodes?.every((building) => building.childNodes?.every(hasDisabledFloorId))
  )
}

const hasCitySelectedFloor: HasSelectedFloor = (treeNode, hasDisabledFloorId) => {
  treeNode.disabled = treeNode.childNodes?.every((building) =>
    building.childNodes?.every(hasDisabledFloorId)
  )
}

const hasBuildingSelectedFloor: HasSelectedFloor = (treeNode, hasDisabledFloorId) => {
  treeNode.disabled = treeNode.childNodes?.every(hasDisabledFloorId)
}

const hasFloorSelectedFloorId: HasSelectedFloor = (treeNode, hasDisabledFloorId) => {
  treeNode.disabled = hasDisabledFloorId(treeNode)
}

const selectedFloorPredicatesMap: { [key in LocationNodeType]: HasSelectedFloor } = {
  [LocationNodeType.Location]: hasLocationSelectedFloor,
  [LocationNodeType.City]: hasCitySelectedFloor,
  [LocationNodeType.Building]: hasBuildingSelectedFloor,
  [LocationNodeType.Floor]: hasFloorSelectedFloorId,
}

const getFloorId = get('nodeData.floor.id')
